// Número de documento: solo dígitos, salvo el pasaporte, que admite letras y
// números (sin espacios, puntos ni guiones, en mayúsculas).
export const isPassportName = (name) => /pasaporte|passport/i.test(String(name || ''));

export const sanitizeDocumentNumber = (value, typeName) =>
  isPassportName(typeName)
    ? String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '')
    : String(value || '').replace(/\D/g, '');
